var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PSkeleton',{attrs:{"is-loading":false}},[_c('img',{staticClass:"object-contain",attrs:{"src":_vm.imgSrc,"alt":""},on:{"load":function($event){_vm.isLoading = false}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }